export const enum AuthStatus {
  Cancel,
  Effective,
  Expired,
}
